// Wheat + blockchain cubes + hex connectors — espello exacto do
// LOGO_MARK_SVG que vive en backend/src/lib/landing/logos.ts. Mantelos
// sincronizados é manual; cando o logo de marca cambie, hai que tocar
// os dous (a SPA non importa nada do backend).

export interface LogoMarkProps {
  size?: number;
  className?: string;
}

export default function LogoMark({ size = 28, className = '' }: LogoMarkProps) {
  return (
    <svg
      viewBox="0 0 64 64"
      width={size}
      height={size}
      xmlns="http://www.w3.org/2000/svg"
      aria-label="LeyroChain"
      className={className}
    >
      <defs>
        <linearGradient id="lc-wheat-header" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#dcbc8a" />
          <stop offset="100%" stopColor="#a8895a" />
        </linearGradient>
      </defs>

      {/* Hexagonal connecting lines */}
      <g
        stroke="#a8895a"
        strokeWidth="0.7"
        opacity="0.7"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M 14,14 L 26,20" />
        <path d="M 50,14 L 38,20" />
        <path d="M 14,50 L 26,44" />
        <path d="M 50,50 L 38,44" />
        <path d="M 26,20 L 26,44" />
        <path d="M 38,20 L 38,44" />
      </g>

      {/* Wheat stalk */}
      <g
        stroke="url(#lc-wheat-header)"
        strokeWidth="1"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M 32,6 L 32,46" />
        <path d="M 32,10 Q 27,12 25,15 Q 27,14 32,12" />
        <path d="M 32,14 Q 27,16 25,19 Q 27,18 32,16" />
        <path d="M 32,18 Q 27,20 25,23 Q 27,22 32,20" />
        <path d="M 32,22 Q 27,24 25,27 Q 27,26 32,24" />
        <path d="M 32,26 Q 27,28 25,31 Q 27,30 32,28" />
        <path d="M 32,30 Q 27,32 25,35 Q 27,34 32,32" />
        <path d="M 32,34 Q 27,36 25,39 Q 27,38 32,36" />
        <path d="M 32,10 Q 37,12 39,15 Q 37,14 32,12" />
        <path d="M 32,14 Q 37,16 39,19 Q 37,18 32,16" />
        <path d="M 32,18 Q 37,20 39,23 Q 37,22 32,20" />
        <path d="M 32,22 Q 37,24 39,27 Q 37,26 32,24" />
        <path d="M 32,26 Q 37,28 39,31 Q 37,30 32,28" />
        <path d="M 32,30 Q 37,32 39,35 Q 37,34 32,32" />
        <path d="M 32,34 Q 37,36 39,39 Q 37,38 32,36" />
        <path d="M 32,46 L 28,54 M 32,46 L 36,54" />
      </g>

      {/* 4 isometric blockchain cubes */}
      <g fill="none" stroke="#c9a96e" strokeWidth="0.9" strokeLinejoin="round">
        {/* Top-left cube at (14,14) */}
        <path d="M 14,10 L 18,12 L 14,14 L 10,12 Z" />
        <path d="M 10,12 L 14,14 L 14,20 L 10,18 Z" />
        <path d="M 18,12 L 14,14 L 14,20 L 18,18 Z" />
        <path d="M 14,14 L 15,14.5 L 14,15 L 13,14.5 Z" fill="#a8895a" stroke="none" />
        {/* Top-right cube at (50,14) */}
        <path d="M 50,10 L 54,12 L 50,14 L 46,12 Z" />
        <path d="M 46,12 L 50,14 L 50,20 L 46,18 Z" />
        <path d="M 54,12 L 50,14 L 50,20 L 54,18 Z" />
        <path d="M 50,14 L 51,14.5 L 50,15 L 49,14.5 Z" fill="#a8895a" stroke="none" />
        {/* Bottom-left cube at (14,50) */}
        <path d="M 14,46 L 18,48 L 14,50 L 10,48 Z" />
        <path d="M 10,48 L 14,50 L 14,56 L 10,54 Z" />
        <path d="M 18,48 L 14,50 L 14,56 L 18,54 Z" />
        <path d="M 14,50 L 15,50.5 L 14,51 L 13,50.5 Z" fill="#a8895a" stroke="none" />
        {/* Bottom-right cube at (50,50) */}
        <path d="M 50,46 L 54,48 L 50,50 L 46,48 Z" />
        <path d="M 46,48 L 50,50 L 50,56 L 46,54 Z" />
        <path d="M 54,48 L 50,50 L 50,56 L 54,54 Z" />
        <path d="M 50,50 L 51,50.5 L 50,51 L 49,50.5 Z" fill="#a8895a" stroke="none" />
      </g>
    </svg>
  );
}
